import { render, staticRenderFns } from "./Mentorships.vue?vue&type=template&id=0550362a&scoped=true&"
import script from "./Mentorships.vue?vue&type=script&lang=js&"
export * from "./Mentorships.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0550362a",
  null
  
)

export default component.exports